import { useIntl } from 'react-intl'

import type { Package } from '../../../../../core/typings'

export const getDeliveryMethodNameFromPkg = (pkg: Package) =>
  pkg.selectedSlaObj?.name ?? ''

export const getDetailsScheduledDelivery = (
  currentPackage: Package,
  shippingValue: string,
  methodName: string
) => {
  const intl = useIntl()

  const deliveryDate = intl.formatDate(
    currentPackage.selectedSlaObj?.deliveryWindow?.startDateUtc
  )

  const weekDay = intl
    .formatDateToParts(
      currentPackage.selectedSlaObj?.deliveryWindow?.startDateUtc,
      { weekday: 'long' }
    )
    .filter((datePart: Intl.DateTimeFormatPart) => datePart.type === 'weekday')

  const startTime = intl.formatTime(
    currentPackage.selectedSlaObj?.deliveryWindow?.startDateUtc
  )

  const endTime = intl.formatTime(
    currentPackage.selectedSlaObj?.deliveryWindow?.endDateUtc
  )

  return `${methodName}, ${deliveryDate}, ${
    weekDay[0].value
  }, ${intl.formatMessage(
    {
      id: 'checkout.shipping-method-selection.schedule-delivery-range',
    },
    {
      startTime,
      endTime,
    }
  )} - ${shippingValue}`
}

export const hasScheduledDelivery = (currentPackage: Package) =>
  !!currentPackage.selectedSlaObj?.deliveryWindow
